import { $4, $$4, $id4 } from '@theme/utilities';
import { inView } from "@theme/m";
import { ThemeEvents } from '@theme/events';
const  { cartUpdate, cartError } = ThemeEvents;
import { Resize } from "@theme/global";

class StickyBar extends Resize {
  #btns;
  #controller;
  #activeClass = 'is--active';
  #variantButton;
  #buyButton;
  constructor() {
    super();
  }
  connectedCallback() {
    const isExternal = $4('.hdt-section-main--product .hdt-product__external');
    if (isExternal) {
      this.classList.remove('hdt-sticky-bar-has-atc');
      $4('[data-form]', this).remove();
    }
    const spyItems = $$4('[data-hdt-spy]'),
    hasBacktop = this.classList.contains('hdt-sticky-bar-has-backtop'),
    hasATC = this.classList.contains('hdt-sticky-bar-has-atc'),
    hasSpy = spyItems.length;
    if (!hasSpy && !hasBacktop && !hasATC) return;
    this.#controller = new AbortController();
    let attr = '';
    if (hasSpy) {
      this.#build(spyItems);
      attr = attr + 'spy';
    }
    if (hasATC) {
      this.#stickyATC();
      attr = attr + 'atc';
    }
    if (hasBacktop) {
      if (attr == '' && this.classList.contains('backtop-active')) {
        return this.classList.remove('hdt-sticky-bar-has-backtop');
      }
      this.#backtoTop();
      attr = attr + 'top';
    }
    if (attr == '') return;
    this.setAttribute('inted', '');
    this.#inView();
    super.connectedCallback();

    if (attr.length == 3) this.setAttribute('only', attr);
    // if (Shopify.designMode) {
    //   document.addEventListener('shopify:section:load', (e) => {
    //   });
    // }
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
  get prefix() {
    return 'sticky-bar';
  }

  #build(spyItems) {
    this.classList.add('hdt-sticky-bar-has-scrollspy')
    const template = $4('template', this);
    if (!template) return;

    // clone template content
    const content = template.content.cloneNode(true),
    container = $4('.hdt-slider__container', content),
    slideTemplate = $4('.hdt-scrollspy-item', content);

    if (!container || !slideTemplate) return;

    // clear container
    container.innerHTML = '';

    // build items
    spyItems.forEach(item => {
      const { id } = item.dataset,
      text = item.textContent.trim();

      if (!id || !text) return;

      const slide = slideTemplate.cloneNode(true),
      btn = $4('button', slide);

      // set content
      btn.textContent = text;
      // set target
      btn.dataset.target = `${id}`;
      container.appendChild(slide);
    });

    // replace template
    template.replaceWith(content);
    this.#btns = $$4('.hdt-scrollspy button', this);
    this.#bindClick();
    this.#initScrollSpy();
  }
  #bindClick() {
    const { signal } = this.#controller;
    this.#btns.forEach((btn, index) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const target = $id4(`shopify-section-${btn.dataset.target}`);

        // window.scrollTo({
        //   top: target.offsetTop,
        //   behavior: 'smooth'
        // });
        target?.scrollIntoView({ behavior: 'smooth' });

        this.#setActive(index);
      }, signal );
    });
  }
  #setActive(index) {
    this.#btns.forEach(link => link.classList.remove(this.#activeClass));
    this.#btns[index].classList.add(this.#activeClass);
  }
  get #firstVisibleSection() {
      const sections = $$4('#MainContent > .shopify-section');
      for (const section of sections) {
          if (section.offsetParent !== null) {
              return section;
          }
      }
      return null;
  }
  #inView() {
    let target = document.forms[$4('[tmp-sticky-atc]')?.dataset.form];
    if (!target || target.offsetParent === null) target = this.#firstVisibleSection;
    if (target) {
      const observer = new IntersectionObserver(([entry]) => {
          if (entry.boundingClientRect.bottom < 0) {
            this.setAttribute('shown', '');
          } else {
            this.removeAttribute('shown');
          }
        },
        { threshold: 0 }
      );
      setTimeout(()=> {
        observer.observe(target);
        setTimeout(() => this.setAttribute('transition', ''), 60);   /* rdg-fix 2026-07-19 : lambda -> setAttribute vraiment differe de 60ms (avant : appele immediatement, setTimeout ne planifiait que 'undefined') */
      }, 60)
    }
  }
  #stickyATC() {
    const form = document.forms[$4('[tmp-sticky-atc]')?.dataset.form];   /* rdg-fix 2026-07-19 : ?. (aligne sur #inView l.133) -> pas de TypeError si [tmp-sticky-atc] absent */
    if (!form) return;
    this.#variantButton = $4('[ref="variantButton"]', this);
    const { signal } = this.#controller;
    // 1. Click atc
    this.#buyButton = form?.querySelector('[type="submit"]');
    this.#variantButton?.addEventListener('click', this.#handleAddToCartClick, { signal });
    document.addEventListener(cartUpdate, this.#handleCartAddComplete.bind(this, false), { signal });
    document.addEventListener(cartError, this.#handleCartAddComplete.bind(this, false), { signal });

    // 2. Update when change variant
    form?.addEventListener('product:updateInfo', this.#updateInfo, { signal });
  }
  #initScrollSpy() {
    this.#btns.forEach( (btn)=> {
      const section = $id4(`shopify-section-${btn.dataset.target}`);
      if (!section) return;
      inView(section, () => {
        this.#btns.forEach(link => link.classList.remove(this.#activeClass));
        btn.classList.add(this.#activeClass);
        return (leaveInfo) => {
         btn.classList.remove(this.#activeClass);
        }
      }, { amount: section.offsetHeight > window.innerHeight ? (window.innerHeight / 3) / section.offsetHeight : 0.3 })
    })
  }
  #backtoTop() {
    $4('.hdt-back-to-top', this)?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }), { signal: this.#controller.signal });
  }
  #handleAddToCartClick = async () => {
    this.#handleCartAddComplete(true);
    this.#buyButton.click();
  };
  #handleCartAddComplete(loading = false) {
    this.#variantButton.toggleAttribute('loading', loading);
  }
  #updateInfo = (event) => {
    const { sectionId, html } = event.detail,
    domFragment = $4(`#shopify-section-${sectionId}`, document.createRange().createContextualFragment(html)),
    stickyAddToCart = $4('template[tmp-sticky-atc]', domFragment);
    if (!stickyAddToCart || !stickyAddToCart.content.children.length) return;   /* rdg-fix 2026-07-19 : garde null (template absent du fragment rechargé -> plus de TypeError au changement de variante) */

    const content = stickyAddToCart.content.cloneNode(true),
    refs = ['variantImage','variantTitle','variantPrice','variantButton'];
    refs.forEach((ref) => {
      const newEl = $4(`[ref="${ref}"]`, content),
      oldEl = $4(`[ref="${ref}"]`, this);
      if (!oldEl || !newEl) return;
      if (ref === refs[3]) {
        const oldAttrs = oldEl.attributes,
        newAttrs = newEl.attributes;
        // remove old attr if exit on new attr
        [...oldAttrs].forEach(attr => {
          if (!newEl.hasAttribute(attr.name)) {
            oldEl.removeAttribute(attr.name);
          }
        });
        // set new attr
        [...newAttrs].forEach(attr => {
          oldEl.setAttribute(attr.name, attr.value);
        });

        // 2. UPDATE CLASS
        oldEl.className = newEl.className;

        // 3. UPDATE CONTENT
        oldEl.innerHTML = newEl.innerHTML;
      } else {
        oldEl.replaceWith(newEl)
      }
    });
  }
}
customElements.define('hdt-sticky-bar', StickyBar);